module.exports = __webpack_public_path__ + "static/img/ki.b6491c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/ki.png
// module id = KKnw
// module chunks = 18